<template>
  <layout title="Videos">
    <div
      class="relative px-8 pt-8 pb-20 mx-auto xl:px-5 max-w-7xl sm:px-6 lg:pt-10 lg:pb-28"
    >
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative mx-auto max-w-7xl">
        <div class="flex flex-col justify-start">
          <h1
            class="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 sm:text-4xl sm:leading-10"
          >
            Videos
          </h1>
          <p class="mt-3 text-xl leading-7 text-gray-500 sm:mt-4">
            Learn more about face authentication and self-sovereign identities
            on the go.
          </p>
        </div>

        <div class="mt-12 gap-5" v-if="showLoading">
          <PuSkeleton
            class="h-96 z-10 rounded-lg flex space-x-4 justify-between"
            :count="2"
          />
          <PuSkeleton
            class="h-96 z-10 rounded-lg flex space-x-4 justify-between mt-4"
            :count="2"
          />
          <PuSkeleton
            class="h-96 z-10 rounded-lg flex space-x-4 justify-between mt-4"
            :count="2"
          />
        </div>
        <div v-else>
          <div class="grid gap-5 mx-auto mt-12 lg:grid-cols-2" v-if="videos">
            <article
              class="flex flex-col overflow-hidden rounded-lg shadow-lg bg-white"
              v-for="(video, index) in videos.data"
              :key="index"
            >
              <div class="h-full">
                <div class="flex flex-col justify-between h-full">
                  <div>
                    <div class="shrink-0">
                      <iframe
                        :src="
                          'https://www.youtube-nocookie.com/embed/' +
                          video.youtube_video_id
                        "
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        class="w-full h-80"
                      ></iframe>
                    </div>
                    <div
                      class="relative flex flex-col justify-between flex-1 p-6"
                    >
                      <div class="flex-1">
                        <h3
                          class="mt-2 text-xl font-semibold leading-7 text-gray-900"
                        >
                          {{ video.title }}
                        </h3>
                        <p class="mt-3 text-base leading-6 text-gray-500">
                          {{ video.description }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <pagination class="mt-10" :data="videos" @changePage="getVideos" />
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const pagination = () =>
  import(
    /* webpackChunkName: "pagination" */ "../Components/Layout/pagination.vue"
  );
export default {
  components: { layout, pagination },
  data() {
    return {
      videos: null,
      showLoading: true,
    };
  },
  created() {
    this.getVideos(1);
  },
  methods: {
    removeHTMLtags(text) {
      return text.replace(/(<([^>]+)>)/gi, "");
    },
    getVideos(page) {
      this.axios.get("/api/videos?page=" + page).then((response) => {
        this.videos = response.data;
        this.showLoading = false;
      });
    },
  },
};
</script>
